import { render } from "./CanadaPage.vue?vue&type=template&id=150a3c0f&scoped=true"
import script from "./CanadaPage.vue?vue&type=script&lang=js"
export * from "./CanadaPage.vue?vue&type=script&lang=js"

import "./CanadaPage.vue?vue&type=style&index=0&id=150a3c0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150a3c0f"]])

export default __exports__